import { Col, Row } from "@amzn/stencil-react-components/layout";
import { TextArea } from "@amzn/stencil-react-components/text-area";
import Button, { ButtonVariant } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { forwardRef } from "react";

export interface ReplyFormProps {
  value: string;
  onChange: (value: string) => void;
  onPost: () => void;
  onCancel: () => void;
  commentId: string;
  useCaseId?: string;
}

export const ReplyForm = forwardRef<HTMLTextAreaElement, ReplyFormProps>(function ReplyForm(
  { value, onChange, onPost, onCancel, commentId, useCaseId },
  ref
) {
  return (
    <Col gridGap="dimensions.spacing.200" padding={{ top: "dimensions.spacing.100" }}>
      <TextArea
        ref={ref}
        placeholder={getString("useCases.discussion.replyPlaceholder")}
        aria-label={getString("useCases.discussion.replyPlaceholder")}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        resize="vertical"
        width="100%"
        minHeight={60}
      />
      <Row gridGap="dimensions.spacing.200">
        <Button
          variant={ButtonVariant.Primary}
          disabled={!value.trim()}
          touchpoint="usecase-post-reply"
          customData={{ commentId, useCaseId }}
          onClick={onPost}
        >
          {getString("useCases.discussion.postReply")}
        </Button>
        <Button
          variant={ButtonVariant.Tertiary}
          touchpoint="usecase-cancel-reply"
          customData={{ commentId, useCaseId }}
          onClick={onCancel}
        >
          {getString("useCases.discussion.cancelReply")}
        </Button>
      </Row>
    </Col>
  );
});
